import { ChangeDetectionStrategy, Component, input, signal, viewChild, ElementRef, WritableSignal, computed } from '@angular/core';
import { decode } from 'html-entities';

@Component({
  selector: 'u-truncate-text',
  templateUrl: './u-truncate-text.component.html',
  styleUrls: ['./u-truncate-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UTruncateText {
  text = input<string>();
  html = input<string>();
  type = input<'regular' | 'file'>('regular');
  tooltipPosition = input<string>();
  lines = input<number>();
  forceAvoidTooltip = input<boolean>();
  element = viewChild<ElementRef>('textElement');
  isOverflowText: WritableSignal<boolean> = signal(true);

  decodedHtml = computed(() => decode(this.html() || ''));
  showTooltip = computed(() => !this.forceAvoidTooltip() && this.isOverflowText());

  startText = computed(() => {
    const text = this.text() || this.decodedHtml();
    if (!text) {
      return '';
    }

    const lastDotIndex = text.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex < 3) {
      return text;
    }

    return text.substring(0, lastDotIndex - 3);
  });

  endText = computed(() => {
    const text = this.text() || this.decodedHtml();
    if (!text) {
      return '';
    }

    const lastDotIndex = text.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex < 3) {
      return '';
    }

    return text.substring(lastDotIndex - 3);
  });

  updateShowTooltip() {
    const el = this.element().nativeElement;
    this.isOverflowText.set(el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight);
  }
}
